import React from "react";
import { isDevelopmentMode } from "../services/base";
import { sendIsUserRegistered, sendUserPhoneOrEmail } from "../services/auth";
import { toast } from "react-toastify";

export default function Timer({ des }) {
  const [countDown, setCountDown] = React.useState(0);
  const [runTimer, setRunTimer] = React.useState(true);
  console.log(des);
  function sendOtp(is_registered) {
    let formData = new FormData();
    if (des) {
      formData.append(
        isDevelopmentMode() ? "identifier" : "destination_address",
        des
      );
    }
    return sendUserPhoneOrEmail(formData, is_registered);
  }
  function repeatOtp() {
    setRunTimer(true);
    setCountDown(60 * 2);
    let formData = new FormData();
    formData.append(
      isDevelopmentMode() ? "identifier" : "destination_address",
      des
    );
    sendIsUserRegistered(formData).then((res) => {
      sendOtp(res.data?.data?.is_registered).then((result) => {
        if (!result) {
          toast.error("فرایند به طور کامل انجام نشد مجددا تلاش فرمایید");
        } else {
          toast.success("کد مجددا ارسال شد ی");
        }
      });
    });
  }

  React.useEffect(() => {
    let timerId;

    if (runTimer) {
      setCountDown(60 * 2);
      timerId = setInterval(() => {
        setCountDown((countDown) => countDown - 1);
      }, 1000);
    } else {
      clearInterval(timerId);
    }

    return () => clearInterval(timerId);
  }, [runTimer]);

  React.useEffect(() => {
    if (countDown < 0 && runTimer) {
      // console.log("expired");
      setRunTimer(false);
      setCountDown(0);
    }
  }, [countDown, runTimer]);

  const seconds = String(countDown % 60).padStart(2, 0);
  const minutes = String(Math.floor(countDown / 60)).padStart(2, 0);

  return (
    <div>
      {runTimer ? (
        <div>
          {minutes}:{seconds}
        </div>
      ) : (
        <span className="text-custom setpointer" onClick={repeatOtp}>
          ارسال مجدد کد
        </span>
      )}
    </div>
  );
}
